/**
 * engineNormalJson_Merge_ArrayBlock.ts - ArrayBlock entry processing for EngineNormalJson
 * Pure ES Module version
 */

import { JsonObject } from '../../../../Assembler/dist/app/json/jsonValue.js';
import type { EngineNormalJson } from './engineNormalJson.js';
import type { TemplateOperation } from '../../../../Assembler/dist/model/templateOperation.js';

import { TemplateOperationKind } from '../../../../Assembler/dist/model/templateOperationKind.js';
/** Parameters for processArrayBlockEntry */
interface ArrayBlockEntryParams {
    keyName: string;
    value: JsonObject;
    appSite: string;
    currentTemplateName: string;
    appView: string | null;
    templateKey: string;
    operations: TemplateOperation[];
    jsonData: JsonObject;
    componentHtml: JsonObject | null;
    genComponentHtml: boolean;
    recursionDepth: number;
    contextJson: JsonObject | null;
    flowStack: string[] | null;
    configJson: JsonObject | null;
    clientMode: boolean;
}

/** Parameters for processArrayBlockSkip */
interface ArrayBlockSkipParams {
    keyName: string;
    currentTemplateName: string;
    templateKey: string;
    operations: TemplateOperation[];
}


/**
 * Process an array skip marker entry (TYPE_ARRAYBLOCK_SKIP)
 * Array skip marker: {{!@ArrayKey}} - skip content and log operation
 */
export function processArrayBlockSkip(engine: EngineNormalJson, params: ArrayBlockSkipParams): string {
    const {
        keyName,
        currentTemplateName,
        templateKey,
        operations
    } = params;

    const skipArrayKey = keyName;

    // Log ArraySkip operation (matching C# format)
    operations.push({
        templateName: templateKey,
        kind: TemplateOperationKind.ArraySkip,
        target: `{{!@${skipArrayKey}}}`,
        replacedWith: `${currentTemplateName}_${skipArrayKey} (skipped)`,
        operations: [] as TemplateOperation[]
    } as TemplateOperation);

    // Append defaultSkipJson for array skip
    return engine._loader!.defaultSkipJson;
}

export const mergeArrayBlockMethods = {
    processArrayBlockEntry(this: EngineNormalJson, params: ArrayBlockEntryParams): string {
        const {
            keyName,
            value,
            appSite,
            currentTemplateName,
            appView,
            templateKey,
            operations,
            jsonData,
            componentHtml,
            genComponentHtml,
            recursionDepth,
            contextJson,
            flowStack,
            configJson,
            clientMode
        } = params;

        const arrayKey = keyName;
        const arrayBlockData = value;

        const resultBuilder = { value: '' };
        this.processArrayBlock(
            resultBuilder,
            arrayKey,
            arrayBlockData,
            appSite,
            currentTemplateName,
            appView,
            templateKey,
            operations,
            jsonData,
            componentHtml,
            genComponentHtml,
            recursionDepth,
            contextJson,
            flowStack,
            configJson,
            clientMode
        );

        return resultBuilder.value;
    }
};
